import { appConstants } from "./Helpers/Constants";

const xor = process.env.REACT_APP_XOR;

function initialDecrypt(key: string): string {
    const encryptedVal = localStorage.getItem(key) || "";
    if (!encryptedVal || !xor) return "";
    if (encryptedVal.startsWith("AESGCM:")) return "";
    return encryptAndDecryptXorString(encryptedVal, xor);
}

export const config = {
    appVersion: "1.49.2",
    betaAppVersion: "1.49.2",
    ngAccesstoken: "",
    ngRefreshToken: "",
    ngBaseUrl: process.env.REACT_APP_NG_BASE_URL,
    feedbackBaseApiUrl: process.env.REACT_APP_FEEDBACK_BASE_API_URL,
    appEnvironment: process.env.REACT_APP_ENVIRONMENT,
    xTenantId: process.env.REACT_APP_X_TENANT_ID,
    xApiKey: process.env.REACT_APP_X_API_KEY,
    pinpointAppId: process.env.REACT_APP_PINPOINT_APP_ID,
    s3: {
        xor,
        accessKey: "",
        secretAccessKey: "",
        region: process.env.REACT_APP_AWS_REGION,
        events: {
            bucketName: process.env.REACT_APP_EVENTS_BUCKET,
            folder: process.env.REACT_APP_EVENTS_FOLDER,
            imagePath: process.env.REACT_APP_S3_IMAGE_PATH,
        },
        recommendations: {
            bucketName: process.env.REACT_APP_RECOMMENDATIONS_BUCKET,
            key: process.env.REACT_APP_RECOMMENDATIONS_KEY,
        },
        mediaEssentials: {
            bucketName: process.env.REACT_APP_MEDIA_ESSENTIALS_BUCKET,
            key: process.env.REACT_APP_MEDIA_ESSENTIALS_KEY,
        },
        paymentEligibleUsers: {
            bucketName: process.env.REACT_APP_PAYMENT_ELIGIBLE_USERS_BUCKET,
            key: process.env.REACT_APP_PAYMENT_ELIGIBLE_USERS_KEY,
        },
        landingPage: {
            bucketName: process.env.REACT_APP_LANDING_PAGE_BUCKET,
        },
        media: {
            bucketName: process.env.REACT_APP_BETA_USER_BUCKET,
            betaUserFilePath: process.env.REACT_APP_BETA_USER_JSON_PATH,
        },
        documents: {
            baseUrl: process.env.REACT_APP_S3_DOCUMENTS_BASE_URL,
            description: process.env.REACT_APP_S3_DOCUMENTS_DESCRIPTION,
        },
    },
    user: {
        memberId: localStorage.getItem("memberId") || "",
        isPlayedMigrated: localStorage.getItem("playedMigrated") === "true",
        isResumeMigrated: localStorage.getItem("resumeMigrated") === "true",
        firstName: localStorage.getItem(appConstants.localStorage.firstName),
        lastName: localStorage.getItem(appConstants.localStorage.lastName),
    },
    firebase: {
        courses: {
            token: initialDecrypt(
                appConstants.localStorage.courseFirebaseToken,
            ),
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
            projectId: process.env.REACT_APP_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId:
                process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        },
        webcast: {
            token: initialDecrypt(
                appConstants.localStorage.webcastsFirebaseToken,
            ),
            apiKey: process.env.REACT_APP_WEBCAST_API_KEY,
            authDomain: process.env.REACT_APP_WEBCAST_AUTH_DOMAIN,
            databaseURL: process.env.REACT_APP_WEBCAST_DATABASE_URL,
            projectId: process.env.REACT_APP_WEBCAST_PROJECT_ID,
            storageBucket: process.env.REACT_APP_WEBCAST_STORAGE_BUCKET,
            messagingSenderId:
                process.env.REACT_APP_WEBCAST_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_WEBCAST_APP_ID,
        },
        logging: {
            apiKey: process.env.REACT_APP_LOGGING_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_LOGGING_FIREBASE_AUTH_DOMAIN,
            databaseURL: process.env.REACT_APP_LOGGING_FIREBASE_DATABASE_URL,
            projectId: process.env.REACT_APP_LOGGING_PROJECT_ID,
            storageBucket:
                process.env.REACT_APP_LOGGING_FIREBASE_STORAGE_BUCKET,
            messagingSenderId:
                process.env.REACT_APP_LOGGING_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_LOGGING_FIREBASE_APP_ID,
        },
        fcm: {
            apiKey: process.env.REACT_APP_FCM_API_KEY,
            authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
            databaseURL: process.env.REACT_APP_FCM_DATABASE_URL,
            projectId: process.env.REACT_APP_FCM_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FCM_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FCM_APP_ID,
            measurementId: process.env.REACT_APP_FCM_MEASUREMENT_ID,
            vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
            appName: "PushNotifications",
        },
    },
    sentry: {
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
        traceSampleRate: 1.0,
    },
    storageQuota: {
        //in GB
        lowerLimit: 2,
        upperLimit: 3,
    },
    downloading: {
        maxDownloadingSize: 250,
    },
    blockSeamless: {
        start: +process.env.REACT_APP_BLOCK_LAUNCH_SEAMLESS_START,
        end: +process.env.REACT_APP_BLOCK_LAUNCH_SEAMLESS_END,
    },
    consentForm: {
        fileName: process.env.REACT_APP_CONSENT_FORM_FILE,
    },
    shortsBaseUrl: process.env.REACT_APP_SHORTS_BASE_URL,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export function encryptAndDecryptXorString(encVal: string, key: string) {
    if (encVal?.length && key?.length) {
        const arrEncVal = encVal.split("");
        const arrKey = key.split("");
        const strLen = arrEncVal.length;
        const keyLen = arrKey.length;
        const StringFromCodePoint = String.fromCodePoint;

        for (let i = 0; i < strLen; i++) {
            arrEncVal[i] = StringFromCodePoint(
                arrEncVal[i].codePointAt(0)! ^
                    arrKey[i % keyLen].codePointAt(0)!,
            );
        }

        return arrEncVal.join("");
    }
    return "";
}

const AES_GCM_PREFIX = "AESGCM:";
const IV_LENGTH = 12;
const SALT_LENGTH = 16;

function stringToUint8Array(str: string): Uint8Array {
    const encoder = new TextEncoder();
    return encoder.encode(str);
}

function arrayBufferToString(buffer: ArrayBuffer): string {
    const decoder = new TextDecoder();
    return decoder.decode(buffer);
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCodePoint(bytes[i]);
    }
    return btoa(binary);
}

function base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.codePointAt(i)!;
    }
    return bytes.buffer;
}

async function deriveKey(
    password: string,
    salt: Uint8Array,
): Promise<CryptoKey> {
    const passwordBuffer = stringToUint8Array(password);
    const importedKey = await crypto.subtle.importKey(
        "raw",
        passwordBuffer as unknown as BufferSource,
        "PBKDF2",
        false,
        ["deriveKey"],
    );

    return crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: salt as unknown as BufferSource,
            iterations: 100000,
            hash: "SHA-256",
        },
        importedKey,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt", "decrypt"],
    );
}

export async function encryptAesGcm(
    plaintext: string,
    keyString: string,
): Promise<string> {
    if (!plaintext?.length || !keyString?.length) {
        return "";
    }

    const salt = crypto.getRandomValues(new Uint8Array(SALT_LENGTH));
    const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
    const key = await deriveKey(keyString, salt);

    const plaintextBuffer = stringToUint8Array(plaintext);
    const ciphertextBuffer = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv: iv as unknown as BufferSource },
        key,
        plaintextBuffer as unknown as BufferSource,
    );

    const combined = new Uint8Array(
        salt.length + iv.length + ciphertextBuffer.byteLength,
    );
    combined.set(salt, 0);
    combined.set(iv, salt.length);
    combined.set(new Uint8Array(ciphertextBuffer), salt.length + iv.length);

    return AES_GCM_PREFIX + arrayBufferToBase64(combined.buffer as ArrayBuffer);
}

export async function decryptAesGcm(
    ciphertext: string,
    keyString: string,
): Promise<string> {
    if (!ciphertext?.length || !keyString?.length) {
        return "";
    }

    const data = ciphertext.startsWith(AES_GCM_PREFIX)
        ? ciphertext.slice(AES_GCM_PREFIX.length)
        : ciphertext;

    const combined = new Uint8Array(base64ToArrayBuffer(data));

    const salt = combined.slice(0, SALT_LENGTH);
    const iv = combined.slice(SALT_LENGTH, SALT_LENGTH + IV_LENGTH);
    const encryptedData = combined.slice(SALT_LENGTH + IV_LENGTH);

    const key = await deriveKey(keyString, salt);

    const decryptedBuffer = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: iv as unknown as BufferSource },
        key,
        encryptedData as unknown as BufferSource,
    );

    return arrayBufferToString(decryptedBuffer);
}

export function isAesGcmEncrypted(value: string): boolean {
    return value?.startsWith(AES_GCM_PREFIX) ?? false;
}

export async function decryptAutoDetect(
    encryptedValue: string,
    keyString: string,
): Promise<string> {
    if (!encryptedValue?.length || !keyString?.length) {
        return "";
    }

    if (isAesGcmEncrypted(encryptedValue)) {
        return decryptAesGcm(encryptedValue, keyString);
    }

    return encryptAndDecryptXorString(encryptedValue, keyString);
}

const MIN_VALID_TOKEN_LENGTH = 20;

function hasControlChar(value: string): boolean {
    for (const char of value) {
        const code = char.codePointAt(0)!;
        if (code <= 0x1f || code === 0x7f) {
            return true;
        }
    }
    return false;
}

export function isValidDecryptedToken(value: string): boolean {
    return value.length > MIN_VALID_TOKEN_LENGTH && !hasControlChar(value);
}

async function safeDecrypt(key: string, xorKey: string): Promise<string> {
    try {
        const encrypted = localStorage.getItem(key) || "";
        if (!encrypted) return "";
        const decrypted = await decryptAutoDetect(encrypted, xorKey);
        if (!isValidDecryptedToken(decrypted)) {
            localStorage.removeItem(key);
            return "";
        }
        return decrypted;
    } catch (e) {
        console.error(`Failed to decrypt ${key}, clearing corrupt value:`, e);
        localStorage.removeItem(key);
        return "";
    }
}

export async function initializeConfigTokens(): Promise<void> {
    const xorKey = config.s3.xor;
    if (!xorKey) return;

    const [courseToken, webcastToken, ngAccessToken, ngRefreshToken] =
        await Promise.all([
            safeDecrypt(appConstants.localStorage.courseFirebaseToken, xorKey),
            safeDecrypt(
                appConstants.localStorage.webcastsFirebaseToken,
                xorKey,
            ),
            safeDecrypt(appConstants.localStorage.ngAccessToken, xorKey),
            safeDecrypt(appConstants.localStorage.ngRefreshToken, xorKey),
        ]);

    config.firebase.courses.token = courseToken;
    config.firebase.webcast.token = webcastToken;
    config.ngAccesstoken = ngAccessToken;
    config.ngRefreshToken = ngRefreshToken;
}
